import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ImageEditor from './ImageEditor';
import GhostCamera from './GhostCamera';
import NotFound from './NotFound';
import BreastAnalysis from './pages/aesthetic/BreastAnalysis';
import NoseAnalysis from './pages/aesthetic/NoseAnalysis';
import JawlineAnalysis from './pages/aesthetic/JawlineAnalysis';
import CosmeticSimulator from './pages/aesthetic/CosmeticSimulator';
import MedicalImagingRoute from './pages/MedicalImagingRoute';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ImageEditor />} />
        <Route path="/image" element={<GhostCamera defaultTab="photos" />} />
        <Route path="/video" element={<GhostCamera defaultTab="videos" />} />
        <Route path="/aesthetic/breast-analysis" element={<BreastAnalysis />} />
        <Route path="/aesthetic/nose-analysis" element={<NoseAnalysis />} />
        <Route path="/aesthetic/jawline-analysis" element={<JawlineAnalysis />} />
        <Route path="/aesthetic/simulator" element={<CosmeticSimulator />} />
        <Route path="/medical-imaging" element={<MedicalImagingRoute />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
